module.exports = __webpack_public_path__ + "static/fastest-implementation-2021-1a70954f20476f0f3ecda94cc7bd6e53.svg";